import { Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { ApiHttp } from 'app/providers';

export interface GetOperatorGoogleFleetTokenRequest {
	GoogleTripId: string;
	XpressOperatorId: number | string;
}

@Injectable()
export class GoogleFleetService {
	constructor(private apiHttp: ApiHttp) {}

	public getFleetEngineToken(messageService: MessageService): Promise<any> {
		return this.apiHttp.post('api/GoogleFleet/FleetEngineToken/Admin', null, messageService);
	}

	public getOperatorFleetEngineToken(
		request: GetOperatorGoogleFleetTokenRequest,
		messageService: MessageService
	): Promise<{ Token: string; ExpiresInSeconds: number; Success?: boolean }> {
		return this.apiHttp.post('api/GoogleFleet/FleetEngineToken/Operator', request, messageService);
	}
}
